<template>
  <div class="flex flex-col md:flex-row gap-3 p-3" dir="rtl">
    <!-- سایدبار تامین‌کننده -->
    <aside
        class="w-full md:w-64 xl:w-72 shrink-0 rounded-2xl border border-gray-200 bg-white p-3 space-y-3"
        v-if="supplier"
    >
      <div class="flex items-start justify-between gap-2">
        <div>
          <div class="text-sm font-bold text-gray-800">
            {{ supplier.name }}
          </div>
          <div class="text-[10px] text-gray-500 mt-0.5">
            داشبورد وضعیت پکینگ و تحویل
          </div>
        </div>
        <div class="flex flex-col items-end gap-1">
          <span
              class="px-2 py-0.5 rounded-full text-[9px] bg-indigo-50 text-indigo-700 border border-indigo-100"
          >
            {{ packages.length }} پکینگ
          </span>
          <span
              class="px-2 py-0.5 rounded-full text-[9px]"
              :class="summary.delivered_percent >= 95
              ? 'bg-emerald-50 text-emerald-700 border border-emerald-100'
              : 'bg-amber-50 text-amber-700 border border-amber-100'"
          >
            تحویل کل: {{ summary.delivered_percent }}٪
          </span>
        </div>
      </div>
      <div class="pt-2 border-t border-gray-100 space-y-1.5 text-[9px]">
        <div class="flex items-center justify-between">
          <span class="text-gray-500">جمع تعداد کل:</span>
          <span class="font-bold text-gray-800">
            {{ summary.planned_qty | toMoney }}
            <span class="font-thin text-[8px] text-gray-700">محصول</span>
          </span>

        </div>
        <div class="flex items-center justify-between">
          <span class="text-gray-500">جمع کل مرجوعی :</span>
          <span class="font-bold text-gray-800">
            {{ summary.returned_qty | toMoney }}
            <span class="font-thin text-[8px] text-gray-700">محصول</span>
          </span>

        </div>
        <div class="flex items-center justify-between">
          <span class="text-gray-500">تعداد کل تحویل‌شده:</span>
          <span class="font-bold text-emerald-700">
            {{ summary.delivered_qty | toMoney }}
            <span class="font-thin text-[8px] text-gray-700">محصول</span>
          </span>
        </div>
        <div class="flex items-center justify-between">
          <span class="text-gray-500">کل مانده:</span>
          <span class="font-bold text-amber-600">
            {{ summary.remaining_qty | toMoney }}
            <span class="font-thin text-[8px] text-gray-700">محصول</span>
          </span>
        </div>
      </div>

      <div class="pt-2 border-t border-gray-100">
        <div class="flex items-center justify-between text-[9px] mb-0.5">
          <span class="text-gray-500">درصد تحویل کل (تعداد)</span>
          <span
              class="font-bold"
              :class="summary.delivered_percent >= 90 ? 'text-emerald-700' : 'text-indigo-700'"
          >
            {{ summary.delivered_percent }}٪
          </span>
        </div>
        <div class="w-full h-1.5 rounded-full bg-gray-100 overflow-hidden">
          <div
              class="h-full rounded-full transition-all"
              :class="summary.delivered_percent >= 90 ? 'bg-emerald-500' : 'bg-indigo-500'"
              :style="{ width: (summary.delivered_percent || 0) + '%' }"
          ></div>
        </div>
      </div>
      <div class="space-y-1.5 text-[9px] text-gray-600">
        <div v-if="supplier.phone">
          <span class="font-semibold text-gray-700">تلفن:</span>
          <span class="mr-1">{{ supplier.phone }}</span>
        </div>
        <div v-if="supplier.address">
          <span class="font-semibold text-gray-700">آدرس:</span>
          <span class="mr-1">{{ supplier.address }}</span>
        </div>
        <div v-if="supplier.bank_card_number">
          <span class="font-semibold text-gray-700">کارت:</span>
          <span class="mr-1 ">{{ supplier.bank_card_number }}</span>
        </div>
        <div v-if="supplier.bank_sheba_number">
          <span class="font-semibold text-gray-700">شبا:</span>
          <span class="mr-1  text-[8px]">{{ supplier.bank_sheba_number }}</span>
        </div>
      </div>
      <div v-if="supplier.brands && supplier.brands.length" class="pt-1 border-t border-gray-100">
        <div class="text-[9px] font-semibold text-gray-700 mb-1">
          برندهای مرتبط:
        </div>
        <div class="flex flex-wrap gap-1">
          <span
              v-for="b in supplier.brands"
              :key="b.id"
              class="px-2 py-0.5 rounded-full bg-gray-50 border border-gray-200 text-[9px] text-gray-700"
          >
            {{ b.name }}
          </span>
        </div>
      </div>

    </aside>

    <main class="flex-1 space-y-3">
      <section
          v-if="!loading && packages.length"
          class="rounded-2xl border border-gray-200 bg-white px-3 py-2"
      >
        <div class="flex items-center justify-between mb-1">
          <div>
            <div class="text-xs font-semibold text-gray-800">
              خلاصه عملکرد همه پکینگ‌های این تامین‌کننده
            </div>
            <div class="text-[9px] text-gray-500">
              مجموع پکینگ‌های چین و داخلی، تفکیک تعداد و مبلغ (تومان)
            </div>
          </div>
          <div class="flex items-center gap-1 text-[8px] text-gray-400">
            <span class="px-2 py-0.5 rounded-full bg-gray-50 border border-gray-100">
              تعداد پکینگ: <b class="text-gray-700">{{ packages.length }}</b>
            </span>
          </div>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-4 gap-2 text-[9px]">
          <div class="flex items-center justify-between p-2 rounded-lg bg-gray-50 border border-gray-100">
            <div class="text-gray-600 font-bold ml-2 text-[10px]">کل پکینگ ها:</div>
            <div class="flex flex-col items-end gap-0.5 text-gray-800">
              <div>
                <span class="font-semibold">{{ summaryQty.planned_qty | toMoney }}</span>
                <span class="text-gray-400 mr-1">عدد</span>
              </div>
              <div v-if="summaryToman">
                <span class="font-semibold">{{ summaryToman.planned_value_toman | toMoney }}</span>
                <span class="text-gray-400 mr-1">تومان</span>
              </div>
            </div>
          </div>
          <div class="flex items-center justify-between p-2 rounded-lg bg-red-50 border border-red-100">
            <div class="text-red-600 font-bold ml-2 text-[10px]">کل مرجوعی ها:</div>
            <div class="flex flex-col items-end gap-0.5 text-red-800">
              <div>
                <span class="font-semibold">{{ summaryQty.returned_qty | toMoney }}</span>
                <span class="text-red-400 mr-1">عدد</span>
              </div>
              <div v-if="summaryToman">
                <span class="font-semibold">{{ summaryToman.returned_value_toman | toMoney }}</span>
                <span class="text-red-400 mr-1">تومان</span>
              </div>
            </div>
          </div>

          <!-- تحویل‌شده -->
          <div class="flex items-center justify-between p-2 rounded-lg bg-emerald-50 border border-emerald-100">
            <div class="text-emerald-700 font-bold ml-2 text-[10px]">تحویل‌شده:</div>
            <div class="flex flex-col items-end gap-0.5 text-emerald-800">
              <div>
                <span class="font-semibold">{{ summaryQty.delivered_qty | toMoney }}</span>
                <span class="text-emerald-500 mr-1">عدد</span>
              </div>
              <div v-if="summaryToman">
                <span class="font-semibold">{{ summaryToman.delivered_value_toman | toMoney }}</span>
                <span class="text-emerald-500 mr-1">تومان</span>
              </div>
            </div>
          </div>

          <!-- مانده -->
          <div class="flex items-center justify-between p-2 rounded-lg bg-amber-50 border border-amber-100">
            <div class="text-amber-700 font-bold ml-2 text-[10px]">مانده:</div>
            <div class="flex flex-col items-end gap-0.5 text-amber-800">
              <div>
                <span class="font-semibold">{{ summaryQty.remaining_qty | toMoney }}</span>
                <span class="text-amber-500 mr-1">عدد</span>
              </div>
              <div v-if="summaryToman">
                <span class="font-semibold">{{ summaryToman.remaining_value_toman | toMoney }}</span>
                <span class="text-amber-500 mr-1">تومان</span>
              </div>
            </div>
          </div>

        </div>
      </section>

      <section
          v-if="byCurrency && byCurrency.length"
          class="rounded-2xl border border-gray-200 bg-white px-3 py-2"
      >
        <div class="flex items-center justify-between mb-1">
          <div class="text-xs font-semibold text-gray-800">
            جمع  بر اساس ارز
          </div>
          <div class="text-[9px] text-gray-500">
            مبالغ در ارز اصلی هر پکینگ
          </div>
        </div>
        <div class="overflow-auto">
          <table class="min-w-full text-[9px] text-right">
            <thead class="bg-gray-50 text-gray-600">
            <tr>
              <th class="px-2 py-1">ارز</th>
              <th class="px-2 py-1 text-center"> کل پکینگ</th>
              <th class="px-2 py-1 text-center"> مرجوعی</th>
              <th class="px-2 py-1 text-center">تحویل‌شده</th>
              <th class="px-2 py-1 text-center">مانده</th>
              <th class="px-2 py-1 text-center">درصد تحویل</th>
            </tr>
            </thead>
            <tbody>
            <tr
                v-for="c in byCurrency"
                :key="(c.currency_id || 'toman') + '-' + c.name"
                class="border-t border-gray-100"
            >
              <td class="px-2 py-1">
                <span class="font-semibold text-gray-800">{{ c.name }}</span>
              </td>
              <td class="px-2 py-1 text-center text-gray-800">
                {{ c.planned_value | toMoney }}
                <span class="font-thin text-[8px] text-gray-700">{{ c.name }}</span>

              </td>
              <td class="px-2 py-1 text-center text-red-800">
                {{ c.returned_value | toMoney }}
                <span class="font-thin text-[8px] text-red-700">{{ c.name }}</span>

              </td>
              <td class="px-2 py-1 text-center text-emerald-700">
                {{ c.delivered_value | toMoney }}
                <span class="font-thin text-[8px] text-gray-700">{{ c.name }}</span>
              </td>
              <td class="px-2 py-1 text-center text-amber-700">
                {{ c.remaining_value | toMoney }}
                <span class="font-thin text-[8px] text-gray-700">{{ c.name }}</span>
              </td>
              <td class="px-2 py-1 text-center">
                  <span :class="percentClass(c.delivered_percent)" class="font-semibold">
                    {{ c.delivered_percent }}٪
                  </span>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </section>
      <section class="rounded-2xl border border-gray-200 bg-white px-3 py-2">
        <div class="flex flex-col md:flex-row md:items-center gap-2 justify-between">
          <div class="flex items-center gap-2">
            <div class="text-xs font-semibold text-gray-800">
              لیست پکینگ‌ها
            </div>
            <span class="text-[9px] text-gray-500">
              چین و داخلی، یکجا
            </span>
          </div>
          <div class="flex flex-wrap gap-2 items-center">
            <input
                v-model.trim="search"
                type="text"
                placeholder="جست‌وجو در عنوان / شماره فاکتور..."
                class="px-2 py-1.5 rounded-lg bg-gray-50 border border-gray-200 text-[9px] text-gray-700 w-40 md:w-52"
            />
            <select
                v-model="typeFilter"
                class="px-2 py-1.5 rounded-lg bg-gray-50 border border-gray-200 text-[9px] text-gray-700"
            >
              <option value="">همه نوع‌ها</option>
              <option value="china">پکینگ چین</option>
              <option value="domestic">پکینگ داخلی</option>
            </select>
            <select
                v-model="sortKey"
                class="px-2 py-1.5 rounded-lg bg-gray-50 border border-gray-200 text-[9px] text-gray-700"
            >
              <option value="registration_date">مرتب‌سازی بر اساس تاریخ</option>
              <option value="delivered_percent">درصد تحویل</option>
              <option value="planned_value">ارزش کل پکینگ</option>
              <option value="delivered_value">ارزش تحویل‌شده</option>
            </select>
            <button
                @click="toggleSortDir"
                class="px-2 py-1.5 rounded-lg bg-gray-800 text-white text-[9px]"
            >
              {{ sortDir === 'desc' ? 'نزولی' : 'صعودی' }}
            </button>
          </div>
        </div>

        <!-- جدول پکینگ‌ها -->
        <div class="mt-2 overflow-auto max-h-[70vh] rounded-xl border border-gray-100">
          <table class="min-w-full text-[9px] text-right">
            <thead class="bg-gray-800 text-gray-50 sticky top-0 z-10">
            <tr>
              <th class="px-2 py-2">نوع</th>
              <th class="px-2 py-2">عنوان پکینگ</th>
              <th class="px-2 py-2">شماره فاکتور</th>
              <th class="px-2 py-2">تاریخ</th>
              <th class="px-2 py-2 text-center">تعداد کل</th>
              <th class="px-2 py-2 text-center">تعداد مرجوعی</th>
              <th class="px-2 py-2 text-center">تحویل شده</th>
              <th class="px-2 py-2 text-center">مانده</th>
              <th class="px-2 py-2 text-center">کل بعد از مرجوعی</th>
              <th class="px-2 py-2 text-center">ارزش تحویل</th>
              <th class="px-2 py-2 text-center">درصد تحویل</th>
              <th class="px-2 py-2 text-left">وضعیت</th>
            </tr>
            </thead>
            <tbody>
            <tr
                v-for="(p, idx) in sortedFilteredPackages"
                :key="p.type + '-' + p.id"
                class="border-t border-gray-100 hover:bg-gray-50 transition-colors cursor-pointer"
                @click="goToPackage(p)"
            >
              <!-- نوع -->
              <td class="px-2 py-1 align-middle">
                  <span
                      class="px-2 py-0.5 rounded-full text-[8px] border"
                      :class="p.type === 'china'
                      ? 'bg-blue-50 text-blue-700 border-blue-200'
                      : 'bg-pink-50 text-pink-700 border-pink-200'"
                  >
                    {{ p.type === 'china' ? 'چین' : 'داخلی' }}
                  </span>
              </td>

              <!-- عنوان -->
              <td class="px-2 py-1 align-middle max-w-[180px]">
                <div class="text-[9px] font-semibold text-gray-800 truncate">
                  {{ p.title || '-' }}
                </div>
              </td>

              <!-- شماره فاکتور -->
              <td class="px-2 py-1 align-middle">
                  <span class=" text-[9px] text-gray-700">
                    {{ p.factor_number || '-' }}
                  </span>
              </td>

              <!-- تاریخ -->
              <td class="px-2 py-1 align-middle text-gray-600">
                {{ p.registration_date | toJalali }}
              </td>

              <!-- تعداد کل -->
              <td class="px-2 py-1 align-middle text-center text-gray-800">
                {{ p.planned_qty | toMoney }}
                <span class="text-gray-500 text-[8px] ">محصول</span>
              </td>
              <td class="px-2 py-1 align-middle text-center text-red-800">
                {{ p.returned_qty | toMoney }}
                <span class="text-red-500 text-[8px] ">محصول</span>
              </td>

              <!-- تحویل شده -->
              <td class="px-2 py-1 align-middle text-center text-emerald-700">
                {{ p.delivered_qty | toMoney }}
                <span class="text-gray-500 text-[8px] ">محصول</span>
              </td>

              <!-- مانده -->
              <td class="px-2 py-1 align-middle text-center">
                  <span
                      :class="p.remaining_qty > 0
                      ? 'text-amber-600'
                      : 'text-emerald-700 font-semibold'"
                  >
                    {{ p.remaining_qty | toMoney }}
                  </span>
                <span class="text-gray-500 text-[8px] ">محصول</span>

              </td>

              <!-- ارزش کل -->
              <td class="px-2 py-1 align-middle text-center text-gray-800">
                {{ (p.planned_value - p.returned_value) | toMoney }}
                <span class="text-gray-500 text-[8px] ">{{ p.currency_name }}</span>

              </td>

              <!-- ارزش تحویل -->
              <td class="px-2 py-1 align-middle text-center text-emerald-700">
                {{ p.delivered_value |  toMoney }}
                <span class="text-gray-500 text-[8px]">{{ p.currency_name }}</span>

              </td>

              <!-- درصد تحویل: نوار + عدد -->
              <td class="px-2 py-1 align-middle">
                <div class="flex flex-col gap-0.5">
                  <div class="flex items-center justify-between text-[8px]">
                      <span
                          :class="percentClass(p.delivered_percent)"
                          class="font-semibold"
                      >
                        {{ p.delivered_percent }}٪
                      </span>
                  </div>
                  <div class="w-full h-1 rounded-full bg-gray-100 overflow-hidden">
                    <div
                        class="h-full rounded-full"
                        :class="barClass(p.delivered_percent)"
                        :style="{ width: (p.delivered_percent || 0) + '%' }"
                    ></div>
                  </div>
                </div>
              </td>

              <td class="px-2 py-1 align-middle text-left">
                <div class="flex flex-col items-end gap-0.5">
                    <span
                        class="px-1.5 py-0.5 rounded-full text-[8px] border"
                        :class="p.is_verified
                        ? 'bg-emerald-50 text-emerald-700 border-emerald-200'
                        : 'bg-gray-50 text-gray-500 border-gray-200'"
                    >
                      {{ p.is_verified ? 'تایید شده' : 'در انتظار تایید' }}
                    </span>
                  <span
                      class="px-1.5 py-0.5 rounded-full text-[8px] border"
                      :class="p.remaining_qty === 0
                        ? 'bg-emerald-50 text-emerald-700 border-emerald-200'
                        : 'bg-amber-50 text-amber-700 border-amber-200'"
                  >
                      {{ p.remaining_qty === 0 ? 'تحویل کامل' : 'در حال تحویل' }}
                    </span>
                </div>
              </td>
            </tr>

            <tr v-if="!sortedFilteredPackages.length && !loading">
              <td colspan="11" class="px-3 py-4 text-center text-[9px] text-gray-400">
                برای این تامین‌کننده پکینگی ثبت نشده.
              </td>
            </tr>

            <tr v-if="loading">
              <td colspan="11" class="px-3 py-4 text-center text-[9px] text-gray-400">
                در حال بارگذاری...
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </section>
      <!-- 🔹 بخش بالانس به تفکیک ارز -->
      <section
          class="rounded-2xl border border-gray-200 bg-white px-3 py-2"
          v-if="balances && balances.currencies && balances.currencies.length"
      >
        <div class="flex items-center justify-between mb-1">
          <div>
            <div class="text-xs font-semibold text-gray-800">
              وضعیت بدهی
            </div>
            <div class="text-[9px] text-gray-500">
              بر اساس تحویل‌شده
            </div>
          </div>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2 text-[9px]">
          <div
              v-for="c in balances.currencies"
              :key="(c.currency_id || 'toman')"
              class="p-2 rounded-xl border border-gray-100 bg-gray-50 space-y-1"
          >
            <div class="flex items-center justify-between">
              <div class="font-semibold text-gray-800">
                {{ c.name }}
              </div>
              <div class="text-[8px] text-gray-800">
                نرخ:
                <span class="text-gray-600">
                  {{ c.exchange_rate_to_toman  | toMoney }}
                </span>
              </div>
            </div>

            <div class="flex items-center justify-between">
              <span class="text-gray-500">بدهی کل:</span>
              <span class="font-bold text-gray-800">
                {{ c.delivered_value | toMoney }}
                <span class="font-thin text-gray-600 text-[8px] mr-1">
                  {{ c.name }}
                </span>

              </span>
            </div>
            <div class="flex items-center justify-between">
              <span class="text-gray-500">جمع پرداخت:</span>
              <span class="font-bold text-blue-800">
                {{ c.paid_total | toMoney }}
                <span class="font-thin text-gray-600 text-[8px] mr-1">
                  {{ c.name }}
                </span>
              </span>
            </div>
            <div class="flex items-center justify-between pt-1 border-t border-gray-100 mt-1">
              <span class="text-gray-500">مانده:</span>
              <span
                  class="font-bold "
                  :class="Number(c.net_value) > 0
                  ? 'text-red-600'
                  : Number(c.net_value) < 0
                    ? 'text-emerald-700'
                    : 'text-gray-700'"
                    >
              <template v-if="Number(c.net_value) > 0">
                <span>{{ c.net_value | toMoney }}</span>
                <span class="font-thin text-gray-600 text-[8px] ">
                  {{ c.name }}
                </span>
                <span class="text-[8px] font-thin mr-1">  بدهکاری به
                {{supplier.name}}
                </span>

              </template>

              <template v-else-if="Number(c.net_value) < 0">
                <span>{{ Math.abs(Number(c.net_value)) | toMoney }}</span>
                <span class="font-thin text-gray-600 text-[8px] ">
                  {{ c.name }}
                </span>
                <span class="text-[8px] font-thin mr-1">  طلبکاری از
                {{supplier.name}}
                </span>
              </template>

              <template v-else>
                تسویه
                <span>({{ c.net_value | toMoney }})</span>
              </template>
                </span>
            </div>
          </div>
        </div>
      </section>

      <section class="rounded-2xl border border-gray-200 bg-white px-3 py-2">
        <div class="flex items-center justify-between mb-1.5 curser-pointer" @click="showPayments = !showPayments">
          <div>
            <div class="text-xs font-semibold text-gray-800">
              پرداخت‌های ما به این تامین‌کننده
            </div>
            <div class="text-[9px] text-gray-500">
              مدیریت پرداخت‌های نقدی و چک، مرتبط یا غیرمرتبط با پکینگ
            </div>
          </div>

          <div class="flex justify-between  gap-2">
            <div class="hidden md:flex flex-col items-end text-[8px] text-gray-500">
            </div>
            <button
                style="max-width: 60px"
                class=" px-2 py-1 justify-end rounded-lg text-[9px] border border-gray-200 bg-gray-50 hover:bg-gray-100 text-gray-600 flex items-center gap-1"
            >
              <span>{{ showPayments ? 'بستن' : 'نمایش' }}</span>
              <span v-if="showPayments">▴</span>
              <span v-else>▾</span>
            </button>
          </div>
        </div>

        <div v-show="showPayments" class="mt-2 space-y-2">
          <div class="flex items-center justify-between bg-gray-800  rounded-t-lg">
            <div class="inline-flex gap-0.5 pt-2">
              <button
                  class="px-3 py-1.5 text-[9px] rounded-t-lg flex items-center gap-1 transition-all mr-3"
                  :class="paymentsTab === 'cash'
                  ? 'bg-emerald-500 text-white shadow-sm'
                  : 'bg-gray-700 text-gray-200 hover:bg-emerald-500'"
                  @click="paymentsTab = 'cash'"
              >
                <span>پرداخت‌های نقدی</span>
                <span
                    v-if="cashPayments && cashPayments.length"
                    class="px-1.5 py-0.5 rounded-md text-[8px] bg-white/15 text-white">
                          {{ cashPayments.length }}
                    </span>
              </button>
              <button class="px-3 py-1.5 text-[9px] rounded-t-lg flex items-center gap-1 transition-all mr-1"
                      :class="paymentsTab === 'check'
                        ? 'bg-indigo-500 text-white shadow-sm'
                        : 'bg-gray-700 text-gray-200 hover:bg-indigo-500'"
                      @click="paymentsTab = 'check'"
              >
                <span>چک‌ها</span>
                <span
                    v-if="checkPayments && checkPayments.length"
                    class="px-1.5 py-0.5 rounded-md text-[8px] bg-white/15 text-white">
                        {{ checkPayments.length }}
              </span>
              </button>
            </div>
          </div>
          <div class="flex justify-end w-full pr-2">
          </div>
          <div
              v-if="paymentsTab === 'cash'"
              class="overflow-auto max-h-[40vh] rounded-lg border border-gray-100"
          >
            <table class="min-w-full text-[9px] text-right">
              <thead class="bg-gray-400 text-gray-50 sticky top-0 z-10">
              <tr>
                <th class="text-center px-2 py-2">تاریخ</th>
                <th class="text-center px-2 py-2">مبلغ</th>
                <th class="text-center px-2 py-2">ارز</th>
                <th class="text-center px-2 py-2">پکینگ</th>
                <th class="text-center px-2 py-2">توضیح</th>
                <th class="flex justify-end w-full p-1">
                  <button
                      style="max-width: 100px;"
                      class="px-3 py-1.5 rounded-md bg-blue-600 hover:bg-blue-700 text-white text-[9px] flex items-center gap-1"
                      @click="openNewPayment(paymentsTab)"
                  >
                    <span>+ ثبت {{ paymentsTab === 'cash' ? 'پرداخت نقدی' : 'چک جدید' }}</span>
                  </button>
                </th>
              </tr>
              </thead>
              <tbody>
              <tr
                  v-for="p in cashPayments"
                  :key="p.id"
                  class="border-t border-gray-100 hover:bg-gray-50 transition-colors"
              >
                <td class="px-2 py-1 text-center">
                  {{ p.paid_at }}
                </td>
                <td class="px-2 py-1 font-bold text-gray-800">
                  {{ p.amount | toMoney }}
                </td>
                <td class="px-2 py-1 text-center">
                  {{ currency_name(p.currency_id) || (p.currency_id ? '' : 'تومان') }}
                </td>
                <td class="px-2 py-1 text-center">
              <span v-if="p.china_package_id" class="text-center">
                چین #{{ p.china_package_id }}
              </span>
                  <span v-else-if="p.domestic_package_id" class="text-center">
                داخلی #{{ p.domestic_package_id }}
              </span>
                  <span v-else class="text-gray-400 text-center">کلی</span>
                </td>
                <td class="px-2 py-1 truncate max-w-[140px] text-center">
                  {{ p.note || '-' }}
                </td>
                <td class="px-2 py-1 text-center ">
                  <button
                      class="px-1.5 py-0.5 text-[8px] rounded bg-white border border-gray-300 text-gray-700 mr-1"
                      @click.stop="openEditPayment('cash', p)"
                  >
                    ویرایش
                  </button>
                  <button
                      class="px-1.5 py-0.5 text-[8px] rounded bg-rose-50 border border-rose-200 text-rose-700"
                      @click.stop="deletePayment('cash', p)"
                  >
                    حذف
                  </button>
                </td>
              </tr>

              <tr v-if="!cashPayments.length && !loadingPayments">
                <td colspan="6" class="px-3 py-3 text-center text-gray-400">
                  پرداخت نقدی ثبت نشده.
                </td>
              </tr>
              </tbody>
            </table>
          </div>

          <div
              v-else
              class="overflow-auto max-h-[40vh] rounded-lg border border-gray-100"
          >
            <table class="min-w-full text-[9px] text-right">
              <thead class="bg-gray-400 text-gray-50 sticky top-0 z-10">
              <tr>
                <th class="px-2 py-2">تاریخ ثبت</th>
                <th class="px-2 py-2">سررسید</th>
                <th class="px-2 py-2">مبلغ (تومان)</th>
                <th class="px-2 py-2">پکینگ</th>
                <th class="px-2 py-2">توضیح</th>
                <th class="flex justify-end w-full p-1">
                  <button
                      style="max-width: 100px;"
                      class="px-3 py-1.5 rounded-md bg-blue-600 hover:bg-blue-700 text-white text-[9px] flex items-center gap-1"
                      @click="openNewPayment(paymentsTab)"
                  >
                    <span>+ ثبت {{ paymentsTab === 'cash' ? 'پرداخت نقدی' : 'چک جدید' }}</span>
                  </button>
                </th>
              </tr>
              </thead>
              <tbody>
              <tr
                  v-for="p in checkPayments"
                  :key="p.id"
                  class="border-t border-gray-100 hover:bg-gray-50 transition-colors"
              >
                <td class="px-2 py-1">
                  {{ p.issue_date }}
                </td>
                <td class="px-2 py-1">
                  {{ p.due_date }}
                </td>
                <td class="px-2 py-1 font-bold text-gray-800">
                  {{ p.amount | toMoney }}
                </td>
                <td class="px-2 py-1">
              <span v-if="p.china_package_id">
                چین #{{ p.china_package_id }}
              </span>
                  <span v-else-if="p.domestic_package_id">
                داخلی #{{ p.domestic_package_id }}
              </span>
                  <span v-else class="text-gray-400">کلی</span>
                </td>
                <td class="px-2 py-1 truncate max-w-[140px]">
                  {{ p.note || '-' }}
                </td>
                <td class="px-2 py-1 text-left">
                  <button
                      class="px-1.5 py-0.5 text-[8px] rounded bg-white border border-gray-300 text-gray-700 mr-1"
                      @click.stop="openEditPayment('check', p)"
                  >
                    ویرایش
                  </button>
                  <button
                      class="px-1.5 py-0.5 text-[8px] rounded bg-rose-50 border border-rose-200 text-rose-700"
                      @click.stop="deletePayment('check', p)"
                  >
                    حذف
                  </button>
                </td>
              </tr>

              <tr v-if="!checkPayments.length && !loadingPayments">
                <td colspan="6" class="px-3 py-3 text-center text-gray-400">
                  چکی ثبت نشده.
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>
    </main>
    <!-- 🔹 Modal: ایجاد/ویرایش پرداخت -->
    <div
        v-if="showPaymentModal"
        class="fixed inset-0 z-[9999] flex items-center justify-center"
        @click.self="closePaymentModal"
    >
      <div class="absolute inset-0 bg-black/40 backdrop-blur-sm"></div>
      <div
          class="relative bg-white rounded-2xl shadow-2xl w-[92vw] max-w-md p-4 space-y-3"
      >
        <div class="flex items-center justify-between mb-1">
          <div class="text-sm font-semibold text-gray-800">
            {{
              paymentType === 'cash'
                  ? (paymentForm.id ? 'ویرایش پرداخت نقدی' : 'ثبت پرداخت نقدی')
                  : (paymentForm.id ? 'ویرایش چک' : 'ثبت چک')
            }}
          </div>
          <button
              class="text-gray-500 hover:text-gray-800 text-xs"
              @click="closePaymentModal"
          >
            ✕
          </button>
        </div>

        <!-- انتخاب پکینگ (اختیاری) -->
        <div class="space-y-1">
          <label class="text-[9px] text-gray-600">
            اتصال به پکینگ (اختیاری)
          </label>
          <select
              v-model="paymentForm.package_key"
              class="w-full px-2 py-1.5 rounded-lg border border-gray-200 bg-gray-50 text-[9px] text-gray-800"
          >
            <option value="">— بدون اتصال به پکینگ —</option>
            <option
                v-for="p in packages"
                :key="'opt-' + p.type + '-' + p.id"
                :value="p.type + ':' + p.id"
            >
              {{ p.type === 'china' ? 'چین' : 'داخلی' }} — {{ p.title || ('#' + p.id) }}
            </option>
          </select>
        </div>

        <div v-if="paymentType === 'cash'" class="space-y-2">
          <div class="grid grid-cols-2 gap-2">
            <div>
              <label class="text-[9px] text-gray-600">مبلغ</label>
              <cleave-money
                  bg-color="text-[10px] w-full px-2 py-1 border border-gray-300 bg-gray-100 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-200 "
                  v-model="paymentForm.amount"
                  label=""
                  :currency-unit="current_currency.name"
              >

              </cleave-money>
            </div>
            <div>
              <label class="text-[9px] text-gray-600">تاریخ پرداخت</label>
              <s-date v-model="paymentForm.paid_at"></s-date>
            </div>
          </div>
          <div>
            <label class="text-[9px] text-gray-600">ارز</label>
            <select
                v-model="paymentForm.currency_id"
                class="text-[10px] w-full px-2 py-1 border border-gray-300 bg-gray-100 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-200 "
            >
              <option :value="null">بدون ارز</option>
              <option
                  v-for="c in currencies"
                  :key="c.id"
                  :value="c.id"
              >
                {{ c.name }}
              </option>
            </select>
          </div>
          <div>
            <label class="text-[9px] text-gray-600">توضیح</label>
            <textarea
                v-model="paymentForm.note"
                rows="2"
                class="text-[10px] w-full px-2 py-1 border border-gray-300 bg-gray-100 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-200 "
            ></textarea>
          </div>
        </div>

        <div v-else class="space-y-2">
          <div class="grid grid-cols-1 gap-2">
            <div>
              <label class="text-[9px] text-gray-600">مبلغ </label>
              <cleave-money
                  bg-color="text-[10px] w-full px-2 py-1 border border-gray-300 bg-gray-100 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-200 "
                  v-model="paymentForm.amount"
                  label=""
                  currency-unit="تومان"
              >

              </cleave-money>
            </div>
            <div>
              <label class="text-[9px] text-gray-600">تاریخ ثبت</label>
              <s-date v-model="paymentForm.issue_date"></s-date>
            </div>
          </div>
          <div>
            <label class="text-[9px] text-gray-600">تاریخ سررسید</label>
            <s-date v-model="paymentForm.due_date"></s-date>
          </div>
          <div>
            <label class="text-[9px] text-gray-600">توضیح</label>
            <textarea
                v-model="paymentForm.note"
                rows="2"
                class="text-[10px] w-full px-2 py-1 border border-gray-300 bg-gray-100 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-200 "
            ></textarea>
          </div>
        </div>

        <!-- Footer -->
        <div class="flex items-center justify-end gap-2 pt-2">
          <button
              class="px-3 py-1.5 rounded-lg bg-gray-100 text-gray-700 text-[9px]"
              @click="closePaymentModal"
          >
            انصراف
          </button>
          <button
              class="px-3 py-1.5 rounded-lg bg-emerald-600 text-white text-[9px] disabled:bg-gray-400"
              :disabled="!canSubmitPayment || savingPayment"
              @click="submitPayment"
          >
            {{ savingPayment ? 'در حال ثبت...' : 'ثبت' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CleaveMoney from "@/components/mcomponents/cleave/Money";
import SDate from "@/components/mcomponents/cleave/SDate";

export default {
  name: 'SupplierDashboard',
  components: {SDate, CleaveMoney},
  props: {
    supplierId: {
      type: [String, Number],
      required: false,
    },
    basePath: {
      type: String,
      default: 'entrance/suppliers/dashboard',
    },
  },
  data() {
    return {
      balances: null,

      cashPayments: [],
      checkPayments: [],
      currencies: [],
      showPayments: true,
      paymentsTab: 'cash',
      showPaymentModal: false,
      paymentType: 'cash',
      paymentForm: {
        id: null,
        amount: null,
        paid_at: '',
        currency_id: null,
        issue_date: '',
        due_date: '',
        note: '',
        package_key: '',
      },
      savingPayment: false,
      loadingPayments: false,
      supplier: null,
      byCurrency: [],
      summaryToman: null,
      summary: {
        planned_qty: 0,
        planned_value: 0,
        delivered_qty: 0,
        delivered_value: 0,
        returned_qty: 0,
        returned_value: 0,
        remaining_qty: 0,
        remaining_value: 0,
        delivered_percent: 0,
      },
      packages: [],
      loading: false,
      error: null,
      search: '',
      typeFilter: '',
      sortKey: 'registration_date',
      sortDir: 'desc',
    };
  },
  computed: {
    current_currency() {
      if (this.paymentForm.currency_id) return this.currencies.find(c => c.id === this.paymentForm.currency_id) || {
        id: 0,
        name: 'تومان',
        exchange_rate_to_toman: 1
      }
      return {id: 0, name: 'تومان', exchange_rate_to_toman: 1}
    },

    canSubmitPayment() {
      const f = this.paymentForm;
      if (!f.amount || Number(f.amount) <= 0) return false;
      if (this.paymentType === 'cash') {
        return !!f.currency_id;
      }
      if (this.paymentType === 'cash') {
        return !!f.paid_at;
      } else {
        return !!f.issue_date && !!f.due_date;
      }
    },

    summaryQty() {
      let planned = 0;
      let delivered = 0;
      let returned = 0;

      (this.packages || []).forEach(p => {
        planned += Number(p.planned_qty || 0);
        delivered += Number(p.delivered_qty || 0);
        returned += Number(p.returned_qty || 0);
      });

      const remaining = Math.max(planned - delivered - returned, 0);
      const percent =
          planned > 0 ? Math.round((delivered / planned) * 100) : 0;

      return {
        planned_qty: planned,
        delivered_qty: delivered,
        returned_qty: returned,
        remaining_qty: remaining,
        delivered_percent: percent,
      };
    },

    resolvedSupplierId() {
      if (this.supplierId) return this.supplierId;
      const q = this.$route && this.$route.query
          ? (this.$route.query.supplier_id || this.$route.query.id)
          : null;
      return q;
    },
    sortedFilteredPackages() {
      let list = this.packages || [];

      if (this.typeFilter) {
        list = list.filter(p => p.type === this.typeFilter);
      }

      const q = (this.search || '').trim().toLowerCase();
      if (q) {
        list = list.filter(p => {
          return (
              (p.title || '').toLowerCase().includes(q) ||
              (p.factor_number || '').toLowerCase().includes(q)
          );
        });
      }

      // sort
      const key = this.sortKey;
      const dir = this.sortDir === 'desc' ? -1 : 1;

      list = [...list].sort((a, b) => {
        let av = a[key];
        let bv = b[key];

        if (key === 'registration_date') {
          av = av || '';
          bv = bv || '';
        } else {
          av = Number(av || 0);
          bv = Number(bv || 0);
        }

        if (av < bv) return -1 * dir;
        if (av > bv) return 1 * dir;
        return 0;
      });

      return list;
    },
  },
  created() {
    this.fetchDashboard();
    this.fetchByCurrency();
    this.fetchBalances();
    this.fetchPayments();
    this.fetchCurrencies();
  },
  methods: {
    currency_name(id) {
      if (id) return this.currencies.find(c => c.id === id).name || 'تومان'
      return 'تومان'
    },
    openNewPayment(type) {
      this.paymentType = type;
      this.showPaymentModal = true;
      this.paymentForm = {
        id: null,
        amount: null,
        paid_at: this.today(),
        currency_id: null,
        issue_date: this.today(),
        due_date: this.today(),
        note: '',
        package_key: '',
      };
    },
    openEditPayment(type, p) {
      this.paymentType = type;

      let package_key = '';
      if (p.china_package_id) package_key = `china:${p.china_package_id}`;
      else if (p.domestic_package_id) package_key = `domestic:${p.domestic_package_id}`;

      if (type === 'cash') {
        this.paymentForm = {
          id: p.id,
          amount: p.amount,
          paid_at: p.paid_at,
          currency_id: p.currency_id || null,
          issue_date: '',
          due_date: '',
          note: p.note || '',
          package_key,
        };
      } else {
        this.paymentForm = {
          id: p.id,
          amount: p.amount,
          paid_at: '',
          currency_id: null,
          issue_date: p.issue_date,
          due_date: p.due_date,
          note: p.note || '',
          package_key,
        };
      }

      this.showPaymentModal = true;
    },
    closePaymentModal() {
      this.showPaymentModal = false;
      this.paymentForm = {
        id: null,
        amount: null,
        paid_at: '',
        currency_id: null,
        issue_date: '',
        due_date: '',
        note: '',
        package_key: '',
      };
      this.savingPayment = false;
    },
    async submitPayment() {
      if (!this.canSubmitPayment || this.savingPayment) return;
      this.savingPayment = true;

      const sid = Number(this.resolvedSupplierId);
      const f = this.paymentForm;

      let china_package_id = null;
      let domestic_package_id = null;
      if (f.package_key) {
        const [t, idStr] = f.package_key.split(':');
        const pid = parseInt(idStr, 10);
        if (t === 'china') china_package_id = pid;
        if (t === 'domestic') domestic_package_id = pid;
      }

      try {
        if (this.paymentType === 'cash') {
          const payload = {
            supplier_id: sid,
            amount: f.amount,
            paid_at: f.paid_at,
            currency_id: f.currency_id || null,
            china_package_id,
            domestic_package_id,
            note: f.note || null,
          };

          const base = 'finance/suppliers/payments/cash/';
          const url = this.endpoint(
              f.id ? `${base}${f.id}/` : base
          );
          const method = f.id ? 'put' : 'post';

          await this.request({
            url,
            method,
            data: payload,
            success: (data) => {
              this.fetchBalances()
              this.fetchPayments()
            },

          });
        } else {
          const payload = {
            supplier_id: sid,
            amount: f.amount,
            issue_date: f.issue_date,
            due_date: f.due_date,
            china_package_id,
            domestic_package_id,
            note: f.note || null,
          };

          const base = 'finance/suppliers/payments/check/';
          const url = this.endpoint(
              f.id ? `${base}${f.id}/` : base
          );
          const method = f.id ? 'put' : 'post';

          await this.request({
            url,
            method,
            data: payload,
            success: (data) => {
              this.fetchBalances()
              this.fetchPayments()
            },

          });
        }

        this.closePaymentModal();
      } catch (e) {
        console.error(e);
        this.savingPayment = false;
      }
    },
    async deletePayment(type, p) {
      if (!confirm('حذف این پرداخت قطعی است. ادامه می‌دهید؟')) return;

      const base =
          type === 'cash'
              ? 'finance/suppliers/payments/cash'
              : 'finance/suppliers/payments/check';

      const url = this.endpoint(`${base}/${p.id}/`);

      try {
        await this.request({
          url,
          method: 'delete',
          success: (data) => {
            this.fetchBalances()
            this.fetchPayments()
          },
        });
      } catch (e) {
        console.error(e);
      }
    },
    today() {
      const d = new Date();
      const m = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      return `${d.getFullYear()}-${m}-${day}`;
    },

    fetchBalances() {
      if (!this.resolvedSupplierId) return;
      const url = this.endpoint(
          `main/suppliers/balance?supplier_id=${this.resolvedSupplierId}`
      );
      this.request({
        url,
        method: 'get',
        success: (data) => {
          this.balances = data || null;
        },
      });
    },
    fetchPayments() {
      if (!this.resolvedSupplierId) return;
      this.loadingPayments = true;
      const sid = this.resolvedSupplierId;

      const cashUrl = this.endpoint(
          `finance/suppliers/payments/cash/?supplier=${sid}`
      );
      const checkUrl = this.endpoint(
          `finance/suppliers/payments/check/?supplier=${sid}`
      );

      this.request({
        url: cashUrl,
        method: 'get',
        success: (data) => {
          this.loadingPayments = false;
          this.cashPayments = Array.isArray(data) ? data : [];
        },
        finally: () => {
          this.loadingPayments = false;

        },
      });

      this.request({
        url: checkUrl,
        method: 'get',
        success: (data) => {
          this.checkPayments = Array.isArray(data) ? data : [];
        },
        finally: () => {
          this.loadingPayments = false;
        },
      });
    },
    fetchCurrencies() {
      const url = this.endpoint('main/currency');
      this.request({
        url,
        method: 'get',
        success: (data) => {
          this.currencies = Array.isArray(data) ? data : [];
        },
      });
    },

    fetchDashboard() {
      if (!this.resolvedSupplierId) {
        this.error = 'شناسه تامین‌کننده مشخص نیست.';
        return;
      }
      this.loading = true;
      this.error = null;

      const url = this.endpoint(
          `${this.basePath}/${this.resolvedSupplierId}`
      );

      this.request({
        url,
        method: 'get',
        success: (data) => {
          this.supplier = data.supplier || null;
          this.summary = data.summary || this.summary;
          this.packages = Array.isArray(data.packages) ? data.packages : [];
          this.loading = false;
        },
        fail: (e) => {
          console.error(e);
          this.error = 'خطا در دریافت اطلاعات تامین‌کننده';
          this.loading = false;
        },
        finally: () => {
          this.loading = false;
        },
      });
    },
    fetchByCurrency() {
      if (!this.resolvedSupplierId) {
        this.error = 'شناسه تامین‌کننده مشخص نیست.';
        return;
      }
      this.loading = true;
      this.error = null;

      const url = this.endpoint(
          `${this.basePath}?supplier_id=${this.resolvedSupplierId}`
      );

      this.request({
        url,
        method: 'get',
        success: (data) => {
          this.byCurrency = data.by_currency || [];
          this.summaryToman = data.summary_toman || null;
        },
        fail: (e) => {
          console.error(e);
          this.error = 'خطا در دریافت اطلاعات تامین‌کننده';
        },
        finally: () => {
          this.loading = false;
        },
      });
    },
    fmt(v) {
      if (v == null) return 0;
      const n = Number(v) || 0;
      return n.toLocaleString('fa-IR');
    },
    money(v) {
      const n = Number(v) || 0;
      if (!n) return '0';
      return n.toLocaleString('fa-IR');
    },
    toggleSortDir() {
      this.sortDir = this.sortDir === 'desc' ? 'asc' : 'desc';
    },
    percentClass(p) {
      const val = Number(p || 0);
      if (val >= 95) return 'text-emerald-700';
      if (val >= 70) return 'text-indigo-700';
      if (val > 0) return 'text-amber-600';
      return 'text-gray-400';
    },
    barClass(p) {
      const val = Number(p || 0);
      if (val >= 95) return 'bg-emerald-500';
      if (val >= 70) return 'bg-indigo-500';
      if (val > 0) return 'bg-amber-500';
      return 'bg-gray-300';
    },
    goToPackage(p) {
      if (!this.$router) return;
      if (p.type === 'china') {
        this.$router.push(`/panel/chinaEntranceDashboard/${p.id}`);
      } else {
        this.$router.push(`/panel/domesticEntranceDashboard/${p.id}`);
      }
    },
  },
};
</script>

<style scoped>
table {
  border-collapse: collapse;
}
</style>
